export const PASSWORD_MIN_LENGTH = 12;

const COMMON_PASSWORDS = new Set([
  '12345678', '123456789', '1234567890', '00000000', '11111111',
  'password', 'password1', 'password123', 'password1234',
  'qwerty', 'qwerty123', 'abc123', 'admin123', 'letmein', 'welcome',
  'iloveyou', '1q2w3e4r',
  'رمزعبور', 'رمزعبور123', 'گذرواژه', 'گذرواژه123', 'سلامسلام',
  'دوستتدارم', 'ایرانایران',
].map(compact));

const SIMPLE_SEQUENCES = [
  '012345678901234567890123456789',
  '987654321098765432109876543210',
  'abcdefghijklmnopqrstuvwxyzabcdefghijklmnopqrstuvwxyz',
  'zyxwvutsrqponmlkjihgfedcbazyxwvutsrqponmlkjihgfedcba',
  'qwertyuiopasdfghjklzxcvbnmqwertyuiopasdfghjklzxcvbnm',
];

function normalize(value) {
  return String(value || '')
    .normalize('NFKC')
    .toLowerCase()
    .replace(/[۰-۹]/g, (digit) => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(digit)))
    .replace(/[٠-٩]/g, (digit) => String('٠١٢٣٤٥٦٧٨٩'.indexOf(digit)))
    .replace(/ي/g, 'ی')
    .replace(/ك/g, 'ک');
}

function compact(value) {
  return normalize(value).replace(/[^\p{L}\p{N}]+/gu, '');
}

function isRepeatedPattern(value) {
  return value.length > 1 && (value + value).indexOf(value, 1) < value.length;
}

function includesPhone(password, phone) {
  const passwordDigits = normalize(password).replace(/\D/g, '');
  const phoneDigits = normalize(phone).replace(/\D/g, '');
  if (phoneDigits.length < 7) return false;
  const variants = [phoneDigits];
  if (phoneDigits.startsWith('0')) variants.push(phoneDigits.slice(1));
  if (phoneDigits.startsWith('98')) variants.push(phoneDigits.slice(2));
  return variants.some((value) => value.length >= 7 && passwordDigits.includes(value));
}

export function getPasswordIssue(password, { phone = '', email = '', fullName = '' } = {}) {
  const length = Array.from(password).length;
  if (length < PASSWORD_MIN_LENGTH) {
    return `رمز عبور باید حداقل ${PASSWORD_MIN_LENGTH.toLocaleString('fa-IR')} نویسه داشته باشد؛ چند واژه نامرتبط کنار هم بنویسید.`;
  }

  const compactPassword = compact(password);
  if (COMMON_PASSWORDS.has(compactPassword)) {
    return 'این رمز عبور بسیار رایج است؛ یک عبارت طولانی و منحصربه‌فرد انتخاب کنید.';
  }
  if (compactPassword.length < 4 || isRepeatedPattern(compactPassword)) {
    return 'رمز عبور نباید از تکرار یک نویسه یا الگوی ساده ساخته شود؛ چند واژه نامرتبط استفاده کنید.';
  }
  if (SIMPLE_SEQUENCES.some((sequence) => sequence.includes(compactPassword))) {
    return 'رمز عبور نباید یک دنباله ساده مثل ۱۲۳۴۵۶ یا abcdef باشد؛ چند واژه نامرتبط استفاده کنید.';
  }
  if (compactPassword.includes('fttx')) {
    return 'نام FTTX را در رمز عبور نگذارید؛ یک عبارت نامرتبط انتخاب کنید.';
  }
  if (includesPhone(password, phone)) {
    return 'شماره موبایل خود را در رمز عبور نگذارید؛ چند واژه نامرتبط انتخاب کنید.';
  }

  const emailLocal = compact(String(email).split('@')[0]);
  if (emailLocal.length >= 3 && compactPassword.includes(emailLocal)) {
    return 'بخش نام ایمیل خود را در رمز عبور نگذارید؛ یک عبارت نامرتبط انتخاب کنید.';
  }

  const compactName = compact(fullName);
  if (compactName.length >= 3 && compactPassword.includes(compactName)) {
    return 'نام خود را در رمز عبور نگذارید؛ چند واژه نامرتبط انتخاب کنید.';
  }
  return '';
}
